import { useEffect, useState, memo } from "react";
import { Line } from "react-chartjs-2";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const SectorMonthlyReport = memo(({ }) => {
    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [reportType, setReportType] = useState("monthly");
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [isLoading, setIsLoading] = useState(true);
    const [viewType, setViewType] = useState("site"); 
    const [viewFormula, setViewFormula] = useState('');
    // Custom plugin to display "No data found"
    const noDataPlugin = {
        id: "noDataPlugin",
        beforeDraw: (chart) => {
            const { datasets } = chart.data;
            const hasData = datasets.some((dataset) => dataset.data.length > 0);
            const ctx = chart.ctx;
            ctx.save();
            ctx.clearRect(0, 0, chart.width, chart.height);
            if (!hasData) {
                
                const { width, height } = chart;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.font = "16px Arial";
                ctx.fillStyle = "#eb9f9d";
                ctx.fillText("Sorry, no data found for your filtered search.", width / 2, height / 2);
            }
              ctx.restore();
        },
    };

    const [topSellerChartData, setTopSellerChartData] = useState({
        labels: [],
        datasets: [
            {
                label: "sector report",
                data: [],
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    });



    const groupBySector = (data) => {
        return data.reduce((acc, item) => {
            const sector = item._id.sector;
            if (!acc[sector]) {
                acc[sector] = [];
            }
            acc[sector].push(item);
            return acc;
        }, {});
    };

    const getRandomColor = () => {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return `rgb(${r}, ${g}, ${b})`;
    };
    const quarterNames = { 1: "Sep-Nov", 2: "Dec-Feb", 3: "Mar-May", 4: "Jun-Aug" };
    
    const getDataForPeriod = (result, labels, reportType) => {
        return result.map((item) => {
            return {
                label: `${item?.sector}`,
                data: labels.map((label) => {
                    const foundItem = item?.data.find((itemValue) => {
                        if (reportType === "weekly") {
                            const date = new Date(itemValue._id.week);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(2, "0");
                            const year = date.getFullYear();
                            const formatted = `${day}/${month}/${year}`;
                            return label === formatted;
                        } else if (reportType === "monthly")  {
                            const monthYearVal = `${itemValue._id.month}/${itemValue._id.year}`;
                            return label === monthYearVal;
                        }
                        else if (reportType === "yearly") {
                            return label === `${itemValue._id.year}`;
                        }
                    });
                    setViewFormula(foundItem 
                        ? (
                            foundItem.amount /
                            (viewType === "site" 
                                ? foundItem.orderCount
                                : foundItem.uniqueClientCount)).toFixed(2) : 0);
                    //return foundItem ? (foundItem.amount / foundItem.orderCount).toFixed(2) : 0;
                   return foundItem
                        ? {
                            x: label,
                            y: parseFloat((
                                foundItem.amount /
                                (viewType === "site"
                                ? foundItem.orderCount
                                : foundItem.uniqueClientCount)
                            ).toFixed(2)),
                            orderCount: foundItem.orderCount,
                            uniqueClientCount: foundItem.uniqueClientCount,
                            amount: foundItem.amount
                            }
                        : { x: label, y: 0, orderCount: 0, uniqueClientCount: 0 };
                }),
                borderColor: getRandomColor(),
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            };
        });
    };
    
    const getUniqueLabels = (data, reportType) => {
        const labelSet = new Set();
        data.forEach(item => {
            if (reportType === "weekly") {
                const date = new Date(item._id.week);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                labelSet.add(`${day}/${month}/${year}`);
            } else if(reportType === "monthly") {
                labelSet.add(`${item._id.month}/${item._id.year}`);
            }
            else if (reportType === "yearly") {
                labelSet.add(`${item._id.year}`);
            }
        });
        return Array.from(labelSet);
    };

    const getDataForQuarter = (result, labels) => {
        return result.map((item) => {
          return {
            label: `${item?.sector}`,
            data: labels.map((label) => {
              const quarterKey = Object.keys(quarterNames).find(key => quarterNames[key] === label);
              const foundItem = item?.data.find((itemValue) => itemValue._id.quarter == quarterKey);
              //return foundItem ? (foundItem.amount / foundItem.orderCount).toFixed(2) : 0;
               return foundItem
                    ? {
                        x: label,
                        y: parseFloat((
                            foundItem.amount /
                            (viewType === "site"
                            ? foundItem.orderCount
                            : foundItem.uniqueClientCount)
                        ).toFixed(2)),
                        orderCount: foundItem.orderCount,
                        uniqueClientCount: foundItem.uniqueClientCount,
                        amount: foundItem.amount
                        }
                    : { x: label, y: 0 };

                }),
            borderColor: getRandomColor(),
            backgroundColor: "rgba(255, 99, 132, 0.5)",
          };
        });
      };

      const extractLabels = (data) => {
        const uniqueQuarters = [...new Set(data.map(item => item._id.quarter))];
        return uniqueQuarters.sort().map(q => quarterNames[q]);
      };
    
    useEffect(() => {
        setIsLoading(true);
        if (reportType !== 'quarterly') {
            const URL3 = BaseUrl + "admin/monthlysectorreport";
    
            http.post(URL3, { reportType, period }).then((response) => {
                setIsLoading(false);
    
                const data = response?.data?.data || [];
                const chartData = groupBySector(data);
                const labels = getUniqueLabels(data, reportType);
    
                const result = Object.keys(chartData).map(sector => ({
                    sector: sector,
                    data: chartData[sector]
                }));
     
                
                // const averageSpent = result.map((item) => {
                //     return {
                //         amount: item[1]
                //             .reduce((totalr, items) => totalr + items.sum, 0)
                //             .toFixed(2), orderCount: item[1]
                //                 .reduce((totalr, items) => totalr + items.orderCount, 0)
                //     }
                // });
                const datasets = getDataForPeriod(result, labels, reportType);
                
                setTopSellerChartData({
                    labels,
                    datasets
                });
    
            }).catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
        }
        else {
            let URL3 = BaseUrl + "admin/monthlysectorreport";
            http
                .post(URL3, { reportType, period })
                .then((response) => {
                    setIsLoading(false);
                    
                    const data = response?.data?.data || [];
                    const chartData = groupBySector(data);
                    const labels = extractLabels(data);

                    const result = Object.keys(chartData).map(sector => ({
                    sector: sector,
                    data: chartData[sector],
                    }));

                    const datasets = getDataForQuarter(result, labels);

                    setTopSellerChartData({
                    labels,
                    datasets,
                    });

                }).catch((err) =>{
                    setIsLoading(false);
                    console.log(err);
                });
                  
        }
    }, [reportType, period, viewType]);

    const changePeriodHandler = (e) => {
        setPeriod(e.target.value);
    };

    const changeHandler = (e) => {
        setReportType(e.target.value);
    };

    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    function centerSinglePointDatasets(chartData) {
        const labels = chartData.labels;
    
        const updatedDatasets = chartData.datasets.map((dataset) => {
            const validPoints = dataset.data
                .map((val, i) => ({ val, i }))
                .filter(({ val }) => val !== 0 && val !== null);
    
            if (validPoints.length === 1) {
                const onlyIndex = validPoints[0].i;
                const centeredData = labels.map((_, i) => (i === onlyIndex ? validPoints[0].val : null));
    
                return {
                    ...dataset,
                    data: centeredData,
                    spanGaps: false, // don't draw line through nulls
                    pointRadius: 4,
                    pointHoverRadius: 6,
                };
            }
    
            return dataset;
        });
    
        return { ...chartData, datasets: updatedDatasets };
    }


    let loadingbuffer = isLoading ? "loading-buffer" : "";
    return (
        <div className={`chart-container chart-week-revenue ${loadingbuffer}`}>
            <div className="chart-Hdr">
                <h2 style={{ textAlign: "left" }}>
                    {/* Average Spend Per Site by Sector analysis{"  "} */}
                  
                    </h2>
                    
                <div className="chart-fltr chart-full-flex">
                    <div className="chart-fltr-left">
                        <select
                            value={viewType}
                            onChange={(e) => setViewType(e.target.value)}
                        >
                            <option value="site">Average Spend Per Site by Sector Analysis</option>
                            <option value="customer">Average Spend Per Customer by Sector Analysis</option>
                        </select>
                        {/* <div className="chart-title" style={{  }}>{viewType === "site"
                            ? "Total Revenue / Total No.of Orders"
                            : "Total Revenue / No. of Customers"}
                        </div> */}
                    </div>
                    
                    <div className="chart-fltr-right">
                        <select style={{ width: '150px' }}
                            value={reportType}
                            onChange={(e) => changeHandler(e)}

                        >  <option value={"weekly"}>Current Week</option>
                        <option value={"monthly"}>Monthly</option>
                        <option value={"quarterly"}>Quarterly</option>
                        <option value={"yearly"}>FY Data</option>
                        </select>
                        {(reportType === 'monthly' || reportType === 'quarterly' || reportType === 'yearly') &&<select
                        style={{ width: "170px" }}
                        value={period}
                        onChange={(e) => changePeriodHandler(e)}
                    >
                        {options}
                    </select>}
                    </div>
                
                
                </div>
            </div>
            {topSellerChartData && (
                <Line
                    data={centerSinglePointDatasets(topSellerChartData)}
                    plugins={[noDataPlugin]}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,

                            },
                            title: {
                                display: false,
                                //text: "Average Spend Per Site by Sector analysis",
                            },
                            datalabels: {
                                display: false,
                                font: {
                                    weight: "bold",
                                },
                                anchor: "end",
                                align: "top",
                                formatter: function (value) {
                                    return "£" + value;
                                },
                            },
                            tooltip: {
                                callbacks: {
                                    title: (tooltipItems) => {
                                        /* for (let i = 0; i < tooltipItems.length; i++) {
                                             const index = tooltipItems[i].label;
                                             const sectorName = tooltipItems[i].dataset.label;
                                             return `${sectorName} ${index}`;
                                         } */
                                        const index = tooltipItems[0].label;

                                        return `${viewType === 'site' ? 'Average Spend Per Site' : 'Average Spend Per Customer'} for ${index}`;
                                    },
                                    label: (tooltipItem) => {
                                        const sectorName = tooltipItem.dataset.label;
                                        const raw = tooltipItem.raw;
                                        const average = raw?.y ?? 0;
                                        const averageFormatted = Number(average).toLocaleString('en-GB', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        });
                                        const lines = [`${sectorName} (£): ${averageFormatted}`];
                                        if (raw?.amount != null) {
                                            const amountStr = raw.amount.toString();
                                            const decimalPart = amountStr.split('.')[1];
                                            const fractionDigits = decimalPart
                                                ? Math.min(decimalPart.length, 2)
                                                : 0;

                                            const formattedAmount = Number(raw.amount).toLocaleString('en-GB', {
                                                minimumFractionDigits: fractionDigits,
                                                maximumFractionDigits: fractionDigits
                                            });

                                            lines.push(`Total Revenue (£): ${formattedAmount}`);
                                        }
                                        if (average > 0 && raw?.orderCount != null && raw?.uniqueClientCount != null) {
                                            if (viewType === "site") {
                                                lines.push(`No. of Orders: ${raw.orderCount}`);
                                            } else {
                                                lines.push(`No. of Customers: ${raw.uniqueClientCount}`);
                                            }
                                        }
                                        return lines;
                                    }
                                },
                            },
                        },
                        scales: {
                            x: {
                              offset: true,
                              grid: {
                                display: false,
                              },
                              ticks: {
                                align: 'center', 
                              },
                            },
                            y: {
                              beginAtZero: true,
                            },
                          },
                        
                    }}
                />
            )}
        </div>
    );
});
